@if (iconSrc()) {
  <img class="device-icon" [src]="iconSrc()" [alt]="os()" />
}
